module.exports = __webpack_public_path__ + "img/qbert_questions_p2.e701f5f5.jpg";